// Not using lodash `isEmpty`, as it treats Numbers and Booleans as empty.
// Moved from *useConditionTypes* checks
function isEmpty (value) {
  return (
    value === undefined ||
    value === null ||
    (typeof value === 'number' && Number.isNaN(value)) ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
  )
}

module.exports = { isEmpty }
